// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2k1Gg","header":"MessagesList_header__mJccd","chat":"MessagesList_chat__2VuMm"};